var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7395 1.11437C18.0829 0.787477 18.5398 0.606756 19.0139 0.610343C19.4879 0.61393 19.9421 0.801545 20.2804 1.1336C20.6188 1.46565 20.815 1.91617 20.8275 2.3901C20.84 2.86402 20.668 3.32428 20.3476 3.67375L10.622 15.8369C10.4548 16.017 10.2529 16.1616 10.0285 16.2619C9.80415 16.3622 9.56185 16.4163 9.3161 16.4208C9.07035 16.4254 8.82621 16.3803 8.59827 16.2884C8.37033 16.1964 8.16327 16.0594 7.98948 15.8856L1.53986 9.436C1.36025 9.26863 1.21619 9.06681 1.11627 8.84256C1.01635 8.61831 0.962623 8.37623 0.958292 8.13077C0.953961 7.88531 0.999116 7.64149 1.09106 7.41385C1.18301 7.18622 1.31986 6.97944 1.49345 6.80584C1.66705 6.63225 1.87383 6.49539 2.10147 6.40345C2.3291 6.3115 2.57292 6.26635 2.81838 6.27068C3.06385 6.27501 3.30592 6.32874 3.53017 6.42866C3.75442 6.52857 3.95625 6.67264 4.12361 6.85225L9.22774 11.9539L17.6932 1.168C17.7084 1.14923 17.7247 1.13133 17.7419 1.11437H17.7395Z",
    fill: "#FF7700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.76477512cf4300208bff133d1e66e4a8.svg";
export { ForwardRef as ReactComponent };